module.exports = __webpack_public_path__ + "static/media/hero.51b42b87.png";